import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { FhqGeneralSettingState } from '@reducers/fhq-general-settings';

export const getFhqGeneralSettings = (state: RootState): FhqGeneralSettingState => state.fhqGeneralSettings;
export const getFhqGeneralSettingsData = createSelector(getFhqGeneralSettings, (settings) => settings?.data);
export const isFhqGeneralSettingsLoading = createSelector(getFhqGeneralSettings, (settings) => settings?.loading);
